export const MuiContainer = {
  root: {
    marginTop: '3rem',
  },
};
